import apiV2 from '@/api/v2';
export const addObjectsToReport = async (reportId, payload) => {
    await apiV2.post(`reports/${reportId}/objects/add`, payload);
};
export const removeObjectsFromReport = async (reportId, payload) => {
    await apiV2.post(`reports/${reportId}/objects/delete`, payload);
};
